import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

import StatusButton from './StatusButton';

import { STATUS } from '../../utils/const';

const StatusPanel = ({
  status,
  handleChange,
  setCloseObjectiveDialogOpen,
  proposedByUser = false,
  setCompletedObjectiveDialogOpen,
  reachLimitOfActiveObjectives
}) => {
  const { t } = useTranslation();

  const useStyles = makeStyles(theme => ({
    moreThanTwoButton: {
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        maxWidth: '315px',
        marginLeft: '-20px'
      }
    }
  }));

  const classes = useStyles();

  const { PROPOSED, DECLINED, PASSIVE, ACTIVE, COMPLETED, FAILED } = STATUS;

  switch (status) {
    case PROPOSED:
      return <>
        { !proposedByUser ?
          <>
            <StatusButton
              label={ t('objective.setStatus.approve') }
              // if user approve the objective -> the status has change to passive
              status={ PASSIVE }
              handleOnClick={ handleChange }
            />
            <StatusButton
              label={ t('objective.setStatus.decline') }
              status={ DECLINED }
              handleOnClick={ handleChange }
            />
          </> :
          <Typography variant={ 'body1' } component={ 'span' }>
            { t('objective.setStatus.waitingForApproveOrDecline') }
          </Typography>
        }
      </>;
    case DECLINED:
      return <StatusButton
        label={ t('objective.setStatus.proposed') }
        status={ PROPOSED }
        handleOnClick={ handleChange }
      />;
    case PASSIVE:
      return <>
        <StatusButton
          label={ t('objective.setStatus.activate') }
          status={ ACTIVE }
          handleOnClick={ handleChange }
          disabled={ reachLimitOfActiveObjectives }
        />
        <StatusButton
          label={ t('objective.setStatus.proposed') }
          status={ PROPOSED }
          handleOnClick={ handleChange }
        />
      </>;
    case ACTIVE:
      return <div className = { classes.moreThanTwoButton }>
        <StatusButton
          label={ t('objective.setStatus.completed') }
          status={ COMPLETED }
          handleOnClick={ setCompletedObjectiveDialogOpen }
        />
        <StatusButton
          label={ t('objective.setStatus.failed') }
          status={ FAILED }
          handleOnClick={ setCloseObjectiveDialogOpen }
        />
        <StatusButton
          label={ t('objective.setStatus.passive') }
          status={ PASSIVE }
          handleOnClick={ handleChange }
        />
      </div>;
    case COMPLETED:
      return <StatusButton
        label={ t('objective.setStatus.active') }
        status={ STATUS.ACTIVE }
        handleOnClick={ handleChange }
      />;
    default:
      return <></>;
  }
};

export default StatusPanel;
